// import Button from '@mui/material/Button';
// import Card from '@mui/material/Card';
// import CardActions from '@mui/material/CardActions';
// import CardContent from '@mui/material/CardContent';
// import CardMedia from '@mui/material/CardMedia';
// import Typography from '@mui/material/Typography';
// import { Link } from 'react-router-dom';
//import './pressRelease.scss';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import BannerImg from '../../../../../public/assets/images/BannersFiles/31.jpg';
import { DataNotFound } from '../../../../components/DataNotFound';
import Loader from '../../../../components/Loader/Loader';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import LoaderModal from '../../../../components/common/LoaderModal';
import PdfViewerModal from '../../../../components/elements/PdfViewerModal';
import PpCmsFilter from '../../../../components/elements/PpCmsFilter';
import StaticBanner from '../../../../components/elements/StaticBanner';
import { getAsync, postAsync } from '../../../../components/helper/axiosHelper';
import { useLocation } from 'react-use';
import { PageHitCountApi } from '../../../../shared/Helper';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export default function PublicPortalDownloadcenter() {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [apiData, setApiData] = useState([]);
  const [pdfBase64, setPdfBase64] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [pagloading, setPagLoading] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [datanotfound, setDatanotfound] = useState(false);
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 10,
  });
  const [sortOrder, setSortOrder] = useState(0);
  const [date, setDate] = useState('');
  const [searchTitle, setSearchTitle] = useState('');

  const { t } = useTranslation();
  const { pathname } = useLocation();

  const SearchFilter = {
    cmsTitle: searchTitle,
    dateFrom: moment(date).format('DD/MM/YYYY') ?? '',
    dateTo: moment(date).format('DD/MM/YYYY') || '',
  };

  useEffect(() => {
    PageHitCountApi(pathname, 0);
  }, []);

  const toggleModal = () => {
    setPdfBase64('');
    setIsOpen(!isOpen);
  };

  const getDtataById = async (id) => {
    try {
      setLoading(true);
      const response = await getAsync(`CMSDownloadCenter/GetCMSCMSDownloadCenterById`, { id });
      const result = response?.data[0];
      if (response) {
        toggleModal();
        setLoading(false);
        setPdfBase64(result?.doc);
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const handleDownloadPDF = async (e, id) => {
    e.preventDefault();
    try {
      const response = await getAsync('CMSDownloadCenter/GetCMSCMSDownloadCenterById', { id: id });
      const result = response?.data[0];
      const link = document.createElement('a');
      link.href = `data:application/pdf;base64,${result?.doc}`;
      link.download = result?.fileName || 'document.pdf';
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  const getData = async () => {
    try {
      setPagLoading(true);
      const response = await postAsync(
        `CMSDownloadCenter/GetUserDownloadCenterSortFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}?order=${sortOrder}&lang=${isActive ? 0 : 1}`,
        SearchFilter,
      );
      const result = response?.data;
      setApiData(result);
      setPageCount(response.page);
      setCurrentPage(response.currentPage);
      if (response) {
        setPagLoading(false);
      }
      if (response?.statusCode == 204) {
        setDatanotfound(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    localStorage.setItem('isHome', true);
    getData();
  }, []);

  const fetchData = async () => {
    const newPage = pageOptions.pageNo + 1;

    try {
      setPageOptions((prev) => ({
        ...prev,
        pageNo: prev.pageNo + 1,
      }));
      const response = await postAsync(
        `CMSDownloadCenter/GetCMSDownloadCenterFilterList/${newPage}/${pageOptions.pageSize}`,
        {},
      );
      const newData = response?.data || [];
      setApiData((prevData) => [...prevData, ...newData]);
      setCurrentPage(response.currentPage);
    } catch (error) {
      console.error(t('Something went wrong, Please try again!'));
      setHasMore(false);
    }
  };

  const onSearch = async () => {
    try {
      setPagLoading(true);
      setDatanotfound(false);
      setPageOptions((pre) => {
        return {
          ...pre,
          pageNo: 1,
        };
      });
      const response = await postAsync(
        `CMSDownloadCenter/GetUserDownloadCenterSortFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}?order=${sortOrder}&lang=${isActive ? 0 : 1}`,
        SearchFilter,
      );
      if (response) {
        setPagLoading(false);
        setApiData(response?.data);
        setPageCount(response.page);
        setCurrentPage(response.currentPage);
      }
      if (response?.statusCode == 204) {
        setDatanotfound(true);
      }
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  return (
    <>
      <div className="">
        <StaticBanner BannerImg={BannerImg} en_US={'Download Center'} />
        <section className="py-5">
          <div className="px-4 pb-3">
            <PpCmsFilter setSortOrder={ setSortOrder } date={ date } setDate={ setDate } getData={ onSearch } setSearchTitle={ setSearchTitle } />
          </div>
          <div className="container flex justify-center">
            {!pagloading && apiData?.length > 0 && (
              <InfiniteScroll
                dataLength={apiData?.length}
                next={currentPage === pageCount ? () => {} : fetchData}
                hasMore={hasMore}
                loader={
                  currentPage === pageCount ? null : (
                    <div className="flex justify-center">
                      <Loader />
                    </div>
                  )
                }
              >
                <div className="max-w-screen-2xl">
                  <div className="grid md:grid-cols-2 grid-cols-1 grid-flow-row md:gap-14 gap-4 container">
                    {apiData?.map((data, index) => (
                      <div
                        data-aos="zoom-in"
                        data-aos-once="true"
                        key={index}
                        className="w-full px-10 bg-white border-2 border-black shadow-sm shadow-gray-200"
                      >
                        <div className="flex flex-col items-center p-10">
                          <h5 className="text-md font-medium pb-7">{data?.date}</h5>
                          <div className="w-30 h-30 text-center cursor-pointer py-7">
                            <svg
                              onClick={() => getDtataById(data?.downloadCenterID)}
                              xmlns="http://www.w3.org/2000/svg"
                              width="50"
                              height="50"
                              viewBox="0 0 18 18"
                            >
                              <g fill="#fa0e0a" stroke="none">
                                <path d="M12.819 14.427c.064.267.077.679-.021.948-.128.351-.381.528-.754.528h-.637v-2.12h.496c.474 0 .803.173.916.644zm3.091-8.65c2.047-.479 4.805.279 6.09 1.179-1.494-1.997-5.23-5.708-7.432-6.882 1.157 1.168 1.563 4.235 1.342 5.703zm-7.457 7.955h-.546v.943h.546c.235 0 .467-.027.576-.227.067-.123.067-.366 0-.489-.109-.198-.341-.227-.576-.227zm13.547-2.732v13h-20v-24h8.409c4.858 0 3.334 8 3.334 8 3.011-.745 8.257-.42 8.257 3zm-12.108 2.761c-.16-.484-.606-.761-1.224-.761h-1.668v3.686h.907v-1.277h.761c.619 0 1.064-.277 1.224-.763.094-.292.094-.597 0-.885zm3.407-.303c-.297-.299-.711-.458-1.199-.458h-1.599v3.686h1.599c.537 0 .961-.181 1.262-.535.554-.659.586-2.035-.063-2.693zm3.701-.458h-2.628v3.686h.907v-1.472h1.49v-.732h-1.49v-.698h1.721v-.784z" />
                              </g>
                            </svg>
                          </div>
                          <h5 className="text-md  font-bold py-7">{isActive ? data?.title : data?.titleEn}</h5>
                          <div className="cursor-pointer" onClick={(e) => handleDownloadPDF(e, data?.downloadCenterID)}>
                            {/* <a href={`data:application/pdf;base64,${data?.doc}`} download> */}
                            <svg
                              version="1.0"
                              xmlns="http://www.w3.org/2000/svg"
                              width="42.000000pt"
                              height="27.000000pt"
                              viewBox="0 0 132.000000 117.000000"
                              preserveAspectRatio="xMidYMid meet"
                            >
                              <g
                                transform="translate(0.000000,117.000000) scale(0.100000,-0.100000)"
                                fill="#2c8452"
                                stroke="none"
                              >
                                <path d="M125 1045 l-25 -24 0 -425 0 -425 25 -26 26 -25 502 0 c276 0 511 3 523 6 11 3 28 18 37 34 15 25 17 70 17 398 l0 370 -31 31 -31 31 -339 0 c-186 0 -339 3 -339 8 0 4 -13 22 -29 40 l-30 32 -141 0 c-136 0 -142 -1 -165 -25z m575 -254 c6 -11 10 -89 10 -183 l0 -162 53 52 c29 29 62 52 73 52 25 0 44 -18 44 -42 0 -22 -196 -218 -218 -218 -21 0 -212 190 -212 211 0 66 43 65 108 -1 27 -27 52 -50 56 -50 3 0 6 78 6 174 0 130 3 176 13 179 27 12 57 6 67 -12z" />
                              </g>
                            </svg>
                            {/* </a> */}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </InfiniteScroll>
            )}
            {pagloading && <LoadingAnimation />}
          </div>
        </section>
      </div>
      {datanotfound && <DataNotFound />}
      {loading && <LoaderModal />}
      {isOpen && pdfBase64 && <PdfViewerModal toggleModal={toggleModal} pdfBase64={pdfBase64} visible={false} />}
    </>
  );
}
